'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        fontSize: variables.SIZES.TEXT_SMALL,
        lineHeight: "16px",
        margin: "4px 0 0 0",
        "&$error": {
            color: variables.COLORS.RED,
        },
    },
    contained: {
        marginLeft: 0,
        marginRight: 0,
    },
};

var MuiFormHelperText = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiFormHelperText = MuiFormHelperText;
exports.light = light;
